import { Layout } from "antd";
import React, { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import "./App.less";
import { MapRoute } from "./components";
import { ISystemState } from "./reducers/system";
import "./App.less";
import { Route, routes } from "./routes";
import { IStoreState } from "./store";
import { createRoute, MenuUtil } from "./utils";

function App() {
  const { user } = useSelector<IStoreState, ISystemState>(
    (state) => state.system
  );
  const route: Route = useMemo(() => {
    const menuVoToList = user ? MenuUtil.menuVoToList(user.menuVoList) : [];
    return createRoute(routes, menuVoToList);
  }, [user]);

  return (
    <Layout className="app">
      <MapRoute route={route} />
    </Layout>
  );
}

export default App;
